/**
 * The energy units
 */
export enum EnergyUnit {
	Co2 = 'CO<sub>2</sub>',
	MWth = 'MW<sub>thermal</sub>',
	MW = 'MW'
}